import React from 'react';
import styles from './OrderManagerList.module.scss';
function OrderManagerList({ children }) {
    return (React.createElement("section", { className: styles.wrap },
        React.createElement("table", { className: styles.table },
            React.createElement("tbody", null, children))));
}
export default OrderManagerList;
